export default "__VITE_ASSET__85e51a97__"